import { render, staticRenderFns } from "./ImoFalForm3MenuForm.vue?vue&type=template&id=569e12ef"
import script from "./ImoFalForm3MenuForm.vue?vue&type=script&lang=js"
export * from "./ImoFalForm3MenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports